export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/tk.34730d8e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};